import { primaryFont, wMedium } from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  border-top: 1px solid #DDD;
  &.maxLimitWrapper {
    /* padding-bottom: 0px; */
  }
  .footer-upper-div{
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-div {
      display: flex;
      align-items: center;
      &:not(:last-child){
        margin-right: 10px;
      }
      svg {
        width: 10px;
        height: 15px;
        margin-right: 3.93px;
        fill: #9DA2A4;
      }
      .icon-title {
        font-family: ${primaryFont};
        font-size: 10px;
        font-weight: ${wMedium};
        line-height: 13.592px;
        letter-spacing: -0.294px;
        color: #9DA2A4;
      }
    }
  }
  .footer-text {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.294px;
    color: #67696A;
    margin:6px 0 0 0;
  }
`;
type Props = {
  maxLimit?: boolean,
} & typeof defaultProps;

const defaultProps = {
  maxLimit: false,
};
const UploadDocumentFooter = function UploadDocumentFooter(props: Props) {
  const { maxLimit } = props;
  const fileType = [
    {
      title: 'JPEG,',
    },
    {
      title: 'PNG,',
    },
    {
      title: 'PDFs,',
    },
    {
      title: 'PPT,',
    },
    {
      title: 'WORD,',
    },
    {
      title: 'TXT,',
    },
    {
      title: 'EXCEL,',
    },
    {
      title: 'CSV',
    },
  ];

  return (
    <Wrapper className={classNames('upload-document-footer', { maxLimitWrapper: maxLimit })}>
      <div className="footer-upper-div">
        {fileType.map((item) => (
          <div className="icon-div">
            <span className="icon-title">{item?.title}</span>
          </div>
        ))}
      </div>
      {maxLimit ? (
        <span className="footer-text">Maximum file size: 100MB</span>
      ) : null}
    </Wrapper>
  );
};
UploadDocumentFooter.defaultProps = defaultProps;
export default UploadDocumentFooter;
